import get from 'lodash.get';
import { config } from '@yola/ws-sdk';

const getYolaCookieName = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  return get(cfg, 'common.authtkt.cookie');
};

export default getYolaCookieName;
